import { reducer as formReducer } from 'redux-form'
import normalizers from '../normalizers/forms'
import { reduxFormPlugin as formHistory } from '../plugins/form_history'

export default formReducer.normalize(normalizers).plugin(formHistory('create'))
